<div class="top-container">
    <div style="width: 100%; padding: 12px 32px; display: flex; justify-content: space-between;">
        <p class="header-title">Cambio de Perfil</p>
       <img (click)="closeDialog()" onKeyDown="" src="../../../assets/icons/gray_close.svg" alt="" class="icon-close"> 
    </div>
</div>
<div class="dialog-container">
    
    <div class="d-flex flex-column align-items-center w-100">

      <span class="fs-14px  w-100">Perfiles Asignados</span>
      <form class="example-form w-100">
        <input type="text"
               placeholder="Sucursal"
               [formControl]="controlSucursal"
               [matAutocomplete]="auto" class="form-control">
        <mat-autocomplete #auto="matAutocomplete">
          @for (street of filteredSucursales | async; track street) {
            <mat-option [value]="street">{{street}}</mat-option>
          }
        </mat-autocomplete>
      </form>
    </div>

    <div class="w-100 d-flex justify-content-end align-items-end mb-4 mt-4">
      <button (click)="aceptarCambio()" class="btn btn-primary">Guardar Cambios</button>
    </div>
</div>
